import CustomerInvitationView from './CustomerInvitationView';

export default CustomerInvitationView;
